import { TimezoneSchema } from '@campai/lib-common/entities'

import { env } from '@/env'

export const getDefaultTimezone = () => TimezoneSchema.parse(env.VITE_SERVER_TZ)
